<template>
  <AtomsGlobalDialog :is-open="dialog?.isOpen" :is-message-container="dialog?.isMessageContainer" @close="close" class="w-[700px]">

    <div class="page-magazine__search mt-10 desktop:mt-6">
      <div class="relative flex-1 flex">
        <AtomsFormsTextInput id="txtSearchArticleLabel" type="search" v-model="searchText" class="flex-1 !border !bg-neutral-50 text-neutral-500 tablet:!pl-6" :placeholder="$t('Vyhledávat štítky')" ref="searchTextbox" @enter="search" />
      </div>

      <MoleculesButtonsButton :show-loader="searchLoading" :secondary="true" class="block aspect-square w-14 p-0 bg-secondary-500 hover:bg-secondary-300" @click="search">
        <AtomsImagesIcon icon="magnifying-glass" size="lg tablet:text-xl" />
      </MoleculesButtonsButton>

    </div>

    <div v-if="searchText.length > 2">
      <div class="my-4 font-bold text-primary-500">{{ $t('Štítky') }}</div>
      <div v-if="searchResults.length" class="flex-wrap items-center gap-2 desktop:flex desktop:flex-[2]">
        <button v-for="label in searchResults" class="page-magazine__label" :class="{'page-magazine__label--selected' : props.selectedLabels?.some(selectedLabel => label.lValue === selectedLabel.lValue)}" @click="updateLabels(label.lValue, label.value)">{{ label.value }}</button>
      </div>
      <div v-else class="text-neutral-500">{{ $t('Nebyly nalezeny žádné štítky. Upravte prosím vyhledávanou frázi.') }}</div>
    </div>

    <div v-if="props.selectedLabels?.length">
      <div class="my-4 font-bold text-primary-500">{{ $t('Vybráno') }}</div>
      <div class="flex-wrap items-center gap-2 desktop:flex desktop:flex-[2]">
        <button v-for="label in props.selectedLabels" class="page-magazine__label" @click="updateLabels(label.lValue, label.value)">
          {{ label.value }}
          <AtomsImagesIcon icon="cross" class="ml-2 text-[0.5rem]" />
        </button>
      </div>
    </div>

  </AtomsGlobalDialog>
</template>
<script setup>

import { useDebounceFn } from '@vueuse/core'

const props = defineProps({
  selectedLabels: Array
});

const locale = useLocale().getLocale();

const emit = defineEmits(['filterApplied']);

const dialog = computed(() => useDialog().get('magazineLabels'));

const close = () => useDialog().close();

const searchText = ref('');
const searchLoading = ref(false);
const searchResults = ref([]);

const search = useDebounceFn(async () => {
  if (searchText.value.length > 2) {
    searchLoading.value = true;

    searchResults.value = (await useApiFetch(`/api/searchMagazineLabels?phrase=${encodeURIComponent(searchText.value)}&currencyId=${locale.currencyId}&languageId=${locale.languageId}`)).search.infoPageFilters.items;
    searchLoading.value = false;
  }
}, 200);

watch(searchText, () => {
  search();
});

const updateLabels = (lValue, value) => {
  emit('filterApplied', { lValue, value });
}

</script>